import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Dialog } from 'primereact/dialog';

import { IAppState } from 'model/IAppState';
import { AiOutlineDollarCircle } from "react-icons/ai";
import RequestACallForm from 'pages/Global/requestCall/RequestACallForm';
import { getCMSAssets } from 'helpers/Uri';

type RequstACallType = 'promo'

type IRequstACallDialogProps = {
    origin?: RequstACallType;
    promoName?: string;
};



const RequstACallDialog: React.FC<IRequstACallDialogProps> = ({ origin = 'promo', promoName }) => {
    const lyriqEOFYPromo = useSelector((state: IAppState) =>
        state.promo.find(promo => promo.name === promoName)
    );

    const selectedDeliveryFromStore = useSelector((state: IAppState) => {
        return state.selectedDelivery;
    });

    const [saveDialog, setSaveDialog] = useState(false);


    const onSaveHide = () => {
        setSaveDialog(false);
    }


    return (
        <div>
            {lyriqEOFYPromo &&
                <div
                    className='promo-contact-button'
                    onClick={() => {
                        setSaveDialog(true);
                    }}
                >
                    <div style={{ width: "57.05px", textAlign: "center" }}>
                        <img src={`${getCMSAssets()}/promotion/Discount Icon.svg`} style={{ width: "40px" }} />
                    </div>
                    <span>{lyriqEOFYPromo?.data[(selectedDeliveryFromStore.Country?.code || "AU") + "PromotionButtonText"]}</span>

                    <img alt='' className='promo-arrow' src={`${getCMSAssets()}/main/arrow-confidence.svg`} />
                </div>
            }

            <Dialog className='save-dialog' visible={saveDialog} position='right'
                onHide={() => onSaveHide()} draggable={false} resizable={true}>
                <RequestACallForm qrCode={lyriqEOFYPromo?.name || ""}
                    afterSubmitSuccess={() => {
                        setSaveDialog(false);
                    }} />
            </Dialog>
        </div>

    )

}


export default RequstACallDialog